import classNames from "classnames";
import {useMainBlogCarousel} from "../model/hooks/useMainBlogCarousel";
import {Svg} from "@/shared/ui/Svg";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {Button} from "@/shared/ui/Button";
import styles from "./MainBlog.module.scss";

type Article = {
    h1: string;
    id: number;
    imgPreview: string;
    img_preview_mobile: string;
    url: string;
}

type Props = {
    titleSection: string;
    link: string;
    linkName: string;
    articles: Article[];
}

export const MainBlog = ({titleSection, link, linkName, articles}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useMainBlogCarousel();

    if (articles.length === 0) return null;

    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <p className={styles.titleSection}>{titleSection}</p>
            </div>
            <div className={styles.carousel}>
                <div className={`globalContainer`}>
                    <div ref={carouselRef} className={styles.carouselViewport}>
                        <div className={styles.carouselContainer}>
                            {articles.map((article) => {
                                return (
                                    <Link
                                        key={article.id}
                                        href={`/blog/${article.url}`}
                                        className={styles.slide}
                                    >
                                        <Picture
                                            src={article.imgPreview}
                                            srcMobile={article.img_preview_mobile}
                                            alt={article.h1}
                                            classes={{root: styles.slideImage}}
                                        />
                                        <p className={styles.slideTitle}>{article.h1}</p>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {articles.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
            <div className={`globalContainer`}>
                <Link href={link}><Button variant={`tertiary`} fullWidth>{linkName}</Button></Link>
            </div>
        </div>
    );
}
